export const dataPreloaderEn = {
    title_1: "CONTINUE ONLY IF YOU ARE OF LEGAL AGE",
    button: "ENTER",
    title_2: "WELCOME TO",
    logo: "/assets/images/el-secreto-logo.svg",
};